import React from 'react';
import { TabButton, TabStrip } from '@/components/CorporateShipper/blocks';

/**
 * The corporate account pages' tab row, and the active tab's content below it. `DrillInPage`'s `Tabs` for the
 * carrier page.
 * @param {{ tabs: import('@/components/DrillInPage').DrillInTab[], value: string, onChange: (value: string) => void }}
 *   props
 */
const CarrierTabs = ({ tabs, value, onChange }) => (
    <>
        <TabStrip role="tablist">
            {tabs.map((tab) => (
                <TabButton
                    key={tab.value}
                    type="button"
                    role="tab"
                    aria-selected={tab.value === value}
                    selected={tab.value === value}
                    onClick={() => onChange(tab.value)}
                >
                    {tab.label}
                </TabButton>
            ))}
        </TabStrip>
        {tabs.find((tab) => tab.value === value)?.content}
    </>
);

export default CarrierTabs;
